export enum ANALYTICS_TRACK_TYPE {
  CHANNEL = "channel",
  STREAMER = "streamer",
  FEED = "feed",
  REWIND = "rewind",
}
